








import Vue from "vue";

import { PropsHasImage, PropsIsChatMessage } from "../../models/chat";

import JzChatMsg from "./JzChatMsg.vue";
import JzChatImgDialog from "./JzChatImgDialog.vue";

interface Props extends PropsHasImage, PropsIsChatMessage {}

interface State {
  isOpened: boolean;
}

interface Methods {
  toggle: () => void;
}

/**
 * As of April 2020, only bot can send image messages
 *
 * @emits image-opened
 * @emits image-closed
 */
export default Vue.extend<State, Methods, {}, Props>({
  components: { JzChatMsg, JzChatImgDialog },

  props: {
    avatarUrl: { type: String, default: undefined },
    type: { type: String, default: "bot" },
    imgUrl: { type: String, required: true },
    captions: { type: String, default: "" }
  },

  data() {
    return {
      isOpened: false
    };
  },

  methods: {
    toggle() {
      this.isOpened = !this.isOpened;

      const event: string = this.isOpened ? "image-opened" : "image-closed";
      this.$emit(event);
    }
  }
});
